<template>
  <div style="margin-top:10px;">
    <div
      style="display:flex;padding:10px;justify-content:space-between;flex-wrap: wrap"
      class=" card"
    >
      <div style="margin:15px auto !important;">
        <p>{{ $t("insight.numberProfiles") }}</p>
        <AdminPointsCumul :props="'all'" />
      </div>
      <div style="margin:15px auto !important;">
        <AdminEnAttenteTermine />
      </div>
      <div style="margin:15px auto !important;">
        <p>{{ $t("admin.ptsCumulsNbColors.ptscumul") }}</p>
        <AdminPointsProfile :props="'all'" />
      </div>
    </div>
    <div style="margin-top:10px;padding:5px;" class="card">
      <div>
        <div>
          <b-field>
            <b-checkbox v-model="afficheNomComplet">{{
              $t("admin.afficheNomPrenom")
            }}</b-checkbox>
          </b-field>
        </div>
      </div>
      <div class="columns mt-1">
        <div
          v-for="(color, key) in insight_backgroundColors.length"
          :key="key"
          :class="
            nb_participants_en_attente !== 0
              ? 'is-one-fifth column separator-vertical-grey'
              : 'is-one-quarter column separator-vertical-grey'
          "
        >
          <b-icon
            :style="'color:' + insight_backgroundColors[key]"
            icon="user"
            size="is-medium"
          ></b-icon>
          <b-table
            :data="colors[key]"
            :striped="true"
            :hoverable="true"
            v-if="insight_resultats.length"
            default-sort="lastname"
            :mobile-cards="false"
          >
            <template>
              <b-table-column v-slot="props" field="lastname" sortable centered>
                <p v-if="!afficheNomComplet">
                  {{ props.row.firstname.substr(0, 1).toUpperCase()
                  }}{{ props.row.lastname.substr(0, 2).toUpperCase() }}
                  <b-tooltip
                    type="is-info"
                    :label="$t('admin.doubleProfil')"
                    v-if="props.row.profil[0].length > 1"
                  >
                    <b-icon
                      pack="fas"
                      icon="adjust"
                      style="color:grey"
                      size="is-small"
                    ></b-icon>
                  </b-tooltip>
                </p>
                <p v-if="afficheNomComplet">
                  {{ props.row.firstname }}{{ " " }}{{ props.row.lastname }}
                  <b-tooltip
                    type="is-info"
                    :label="$t('admin.doubleProfil')"
                    v-if="props.row.profil[0].length > 1"
                  >
                    <b-icon
                      v-if="props.row.profil[0].length > 1"
                      pack="fas"
                      icon="adjust"
                      style="color:grey"
                      size="is-small"
                    ></b-icon>
                  </b-tooltip>
                </p>
              </b-table-column>
            </template>
          </b-table>
          <br />
        </div>
        <div v-if="nb_participants_en_attente !== 0" class="column">
          <b-icon style="color:grey" icon="user-edit" size="is-medium"></b-icon>
          <b-table
            :data="participants_en_attente"
            :striped="true"
            :hoverable="true"
            v-if="participants_en_attente.length"
            default-sort="lastname"
            :mobile-cards="false"
          >
            <template>
              <b-table-column
                v-slot="props"
                field="lastname"
                width="40"
                sortable
                centered
              >
                <p v-if="!afficheNomComplet && props.row.profil === null">
                  {{ props.row.firstname.substr(0, 1).toUpperCase()
                  }}{{ props.row.lastname.substr(0, 2).toUpperCase() }}
                </p>
                <p v-if="afficheNomComplet && props.row.profil === null">
                  {{ props.row.firstname }}{{ " " }}{{ props.row.lastname }}
                </p>
              </b-table-column>
            </template> </b-table
          ><br /><br />
        </div>
      </div>
      <AdminFinishedParticipants
        v-if="!insight_nb_participants"
        :type="'noRegistered'"
      />
    </div>

    <br />
  </div>
</template>
<script>
import AdminPointsCumul from "@/components/insight/PageDashboard/AdminPointsCumul";
import AdminPointsProfile from "@/components/insight/PageDashboard/AdminPointsProfile";
import AdminEnAttenteTermine from "@/components/insight/PageDashboard/AdminEnAttenteTermine";
import AdminFinishedParticipants from "@/components/insight/Utils/AdminFinishedParticipants";
import EventBus from "../../../eventBus";

import { mapGetters } from "vuex";

export default {
  components: {
    AdminPointsProfile,
    AdminPointsCumul,
    AdminEnAttenteTermine,
    AdminFinishedParticipants,
  },
  data() {
    return {
      afficheNomComplet: false,
    };
  },
  computed: {
    ...mapGetters([
      "insight_resultats",
      "nb_participants_en_attente",
      "insight_nb_participants",
      "array_participants_termine",
      "colors",
      "participants_en_attente",
      "insight_backgroundColors",
    ]),
  },
  created() {
    this.calcul_pts_color_checkbox("PtsColorsGlobale");
  },
  methods: {
    calcul_pts_color_checkbox(PtsColorsCheckboxs) {
      EventBus.$emit("calcul_pts_color_checkbox", PtsColorsCheckboxs);
    },
  },
};
</script>
